module.exports = __webpack_public_path__ + "static/img/Firefox.84fc921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Firefox.png
// module id = tHTi
// module chunks = 3